import {useMemo, useState} from 'react';
import {useStoreContext} from '../../../../../../../../../store/store-context';
import {Button} from '../../../../../../../../../ui/atoms/button';
import {VerticalSpacer} from '../../../../../../../../../ui/atoms/spacer';
import {useNavigate} from 'react-router';
import {
  Body1,
  Body2,
  Headline3,
} from '../../../../../../../../../ui/atoms/typography';
import {TextField} from '../../../../../../../../../ui/molecules/field/textfield';

import {SeatDiv, SeatsDiv} from '../billing-not-active.styles';

export const BillingSeats = () => {
  const {
    billingRoutesStore: {activateInactiveBillingTabs},
    billingsStore: {chosenBillingPlanType, numSeats, setNumSeats},
    authStore: {featureLimitStatus},
    usersStore: {users, allUsers},
  } = useStoreContext();

  const occupiedSeats = useMemo(() => {
    const reportedSeats = Number(featureLimitStatus?.currentStatus?.seats);
    if (Number.isFinite(reportedSeats) && reportedSeats > 0)
      return reportedSeats;

    return Math.max(
      1,
      (allUsers?.length ? allUsers : users || []).filter(
        (user: any) =>
          user?.status !== 'deactivated' && user?.status !== 'suspended',
      ).length,
    );
  }, [allUsers, featureLimitStatus?.currentStatus?.seats, users]);

  const [seats, setSeats] = useState<number>(
    Math.max(occupiedSeats, Number(numSeats) || occupiedSeats),
  );
  const [error, setError] = useState<string>();
  const handleSetSeats = (e: any) => {
    setSeats(Number(e.target.value));
    setError(undefined);
  };
  const navigate = useNavigate();

  const reserveSeats = () => {
    if (!Number.isInteger(seats) || seats < occupiedSeats) {
      setError(
        `Enter at least ${occupiedSeats} seat${
          occupiedSeats === 1 ? '' : 's'
        } for your current members.`,
      );
    } else {
      setNumSeats(seats);
      activateInactiveBillingTabs('billingCycle');
      navigate(
        `/workspace-settings/billing-cycle?billingPlan=${chosenBillingPlanType}`,
      );
    }
  };
  return (
    <SeatsDiv>
      <SeatDiv>
        <div className="header">
          <Button
            kind="secondary"
            style={{padding: '8px 16px'}}
            onClick={() => activateInactiveBillingTabs('plans')}>
            Back to plans
          </Button>
        </div>
        <div className="content">
          <Headline3 align="left">Choose your seats</Headline3>
          <VerticalSpacer size="8px" />
          <Body1 kind="textBody" align="left">
            A seat is one active workspace member. You currently use{' '}
            {occupiedSeats}.
          </Body1>
          <VerticalSpacer size="16px" />
          <Body2 kind="textBody" align="left">
            Add room for teammates you plan to invite. Billing uses the total
            number of seats selected below.
          </Body2>
          <VerticalSpacer size="25px" />
          <TextField
            placeholder="Number of seats"
            type="number"
            min={occupiedSeats}
            step={1}
            value={seats}
            onChange={handleSetSeats}
            helper={error || ''}
            state={error ? 'error' : 'default'}
          />
          <VerticalSpacer size="32px" />
          <Button width="full" onClick={reserveSeats}>
            Review billing cycle
          </Button>
        </div>
      </SeatDiv>
    </SeatsDiv>
  );
};
